(() => {
  const wrapper = document.querySelector('[data-filter-wrapper]');

  if (!wrapper) return;

  let frameId;

  const orderSoldOutProducts = () => {
    const grid = wrapper.querySelector('#product-grid');

    if (!grid) return;

    const soldOutCards = Array.from(
      grid.querySelectorAll(':scope > card-product[data-product-sold-out]')
    );

    if (!soldOutCards.length) return;

    const infiniteScroll = wrapper.querySelector(
      '[data-infinite-scroll] infinite-scroll'
    );
    const hasMoreProducts = Boolean(infiniteScroll?.dataset.next);
    const gridChildren = Array.from(grid.children);
    const firstSoldOutIndex = gridChildren.findIndex(card =>
      card.matches('card-product[data-product-sold-out]')
    );
    const soldOutProductsAreLast =
      firstSoldOutIndex < 0 ||
      gridChildren
        .slice(firstSoldOutIndex)
        .every(card => card.matches('card-product[data-product-sold-out]'));

    soldOutCards.forEach(card => {
      card.hidden = hasMoreProducts;
    });

    if (!soldOutProductsAreLast) {
      soldOutCards.forEach(card => grid.appendChild(card));
    }
  };

  const scheduleOrder = () => {
    window.cancelAnimationFrame(frameId);
    frameId = window.requestAnimationFrame(orderSoldOutProducts);
  };

  new MutationObserver(scheduleOrder).observe(wrapper, {
    childList: true,
    subtree: true
  });

  scheduleOrder();
})();
